

// import React from 'react';
// import { NavLink } from 'react-router-dom';
// import './css/sidebar.css';
// import Navbar from './Navbar';

// // All possible menu items
// const allMenuItems = [
//   { path: '/', key: 'dashboard', label: 'Dashboard' },
//   { path: '/manage-customers', key: 'customers', label: 'Customers List' },
//   { path: '/users', key: 'users', label: 'Users' },
//   { path: '/rates', key: 'rates', label: 'Rates' },
//   { path: '/inventory', key: 'inventory', label: 'Inventory' },
//   { path: '/orders', key: 'orders', label: 'Orders' },
//   { path: '/purchase-order', key: 'purchase-order', label: 'Purchase Order' },
//   { path: '/packing-list', key: 'packing-list', label: 'Packing List' },
//   { path: '/purchase-expenses', key: 'purchase-expenses', label: 'Purchase & Expenses' },
//   { path: '/reports', key: 'reports', label: 'Reports' },
//   { path: '/access', key: 'access', label: 'Access Control' },
// ];

// function Sidebar({ user }) {
//   console.log("user:",user);
//   const getMenuItems = () => {
//     if (user?.role === 'admin') {
//       // Admin sees everything
//       return allMenuItems;
//     }

//     // Non-admin users: filter based on assigned routes
//     const allowedRoutes = (user?.routes || []).filter(r => r.allowed).map(r => r.route);
    
//     return allMenuItems.filter(item => allowedRoutes.includes(item.key));
//   };

//   return (
//     <div className="sidebar">
//       <div className="logo">Ideal Garments</div>
//       <ul className="menu">
       
//         {getMenuItems().map((item) => (
//           <li key={item.path}>
//             <NavLink 
//               to={item.path} 
//               className={({ isActive }) => isActive ? 'active' : ''}
//               end={item.path === '/'}
//               title={item.label}
//             >
//               {item.label}
//             </NavLink>
//           </li>
//         ))}
//       </ul>
//       <div style={{position:'absolute',bottom:50}}>
//       <Navbar title='Logout'></Navbar>
//       </div>
//     </div>
//   );
// }

// export default Sidebar;
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Toolbar,
  Typography,
  Divider,
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
  Button
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  People as UsersIcon,
  AttachMoney as RatesIcon,
  Inventory as InventoryIcon,
  ShoppingCart as OrdersIcon,
  Group as CustomersIcon,
  Receipt as PurchaseOrderIcon,
  Assignment as PackingListIcon,
  MoneyOff as PurchaseExpensesIcon,
  BarChart as ReportsIcon,
  VpnKey as AccessIcon,
  Close as CloseIcon,
  ExitToApp as LogoutIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import colors from '../theme/Colors';

const drawerWidth = 240;

const allMenuItems = [
  { path: '/', key: 'dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
  { path: '/manage-customers', key: 'customers', label: 'Customers List', icon: <CustomersIcon /> },
  { path: '/users', key: 'users', label: 'Users', icon: <UsersIcon /> },
  { path: '/rates', key: 'rates', label: 'Rates', icon: <RatesIcon /> },
  { path: '/inventory', key: 'inventory', label: 'Inventory', icon: <InventoryIcon /> },
  { path: '/orders', key: 'orders', label: 'Orders', icon: <OrdersIcon /> },
  { path: '/purchase-order', key: 'purchase-order', label: 'Purchase Order', icon: <PurchaseOrderIcon /> },
  { path: '/packing-list', key: 'packing-list', label: 'Packing List', icon: <PackingListIcon /> },
  { path: '/purchase-expenses', key: 'purchase-expenses', label: 'Purchase & Expenses', icon: <PurchaseExpensesIcon /> },
  { path: '/reports', key: 'reports', label: 'Reports', icon: <ReportsIcon /> },
  { path: '/access', key: 'access', label: 'Access Control', icon: <AccessIcon /> },
];

function Sidebar({ user, isOpen, onClose }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  const getMenuItems = () => {
    if (user?.role === 'admin') {
      return allMenuItems;
    }

    const allowedRoutesKeys = (user?.routes || []).filter(r => r.allowed).map(r => r.route);
    return allMenuItems.filter(item => allowedRoutesKeys.includes(item.key));
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
      window.location.reload();
    toast.success('Logged out successfully!');
    navigate('/login');
  };

  const drawerContent = (
    <Box
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: '#2c3e50',
          color: 'white',
        },
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          minHeight: '64px',
          backgroundColor: colors.primary,
          color: 'white',
        }}
      >
        <Typography variant="h6" noWrap component="div">
          Ideal Garments
        </Typography>
        {isSmallScreen && (
          <IconButton onClick={onClose} sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        )}
      </Toolbar>
      <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />
      <List sx={{ flexGrow: 1 }}>
        {getMenuItems().map((item) => (
          <ListItem
            button
            key={item.path}
            component={NavLink}
            to={item.path}
            onClick={isSmallScreen ? onClose : undefined}
            sx={{
              '&.active': {
                backgroundColor: colors.primary,
                '& .MuiListItemIcon-root': {
                  color: 'black', // Active icon color (light green)
                },
                '& .MuiListItemText-primary': {
                  fontWeight: 'bold',
                },
              },
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
              },
              color: 'white', // Default text color for the list item
            }}
            end={item.path === '/'}
          >
            {/* THIS IS THE KEY CHANGE: Explicitly set color for ListItemIcon */}
            <ListItemIcon sx={{ color: colors.primary }}>{item.icon}</ListItemIcon>
            <ListItemText sx={{color:'black'}} primary={item.label} />
          </ListItem>
        ))}
      </List>
      <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.1)' }} />
      <Box sx={{ padding: 2 }}>
        <Button
          variant="contained"
          fullWidth
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
          sx={{
            backgroundColor: '#e74c3c',
            '&:hover': {
              backgroundColor: '#c0392b',
            },
            color: 'white',
            fontWeight: 'bold',
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );

  return (
    <Drawer
      position={'absolute'}
      zIndex={1}
      variant={isSmallScreen ? 'temporary' : 'permanent'}
      open={isSmallScreen ? isOpen : true}
      onClose={onClose}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
       
      }}
    >
      {drawerContent}
    </Drawer>
  );
}

export default Sidebar;
